import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const ICTSupplyFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How do I know I’m buying the right ICT equipment?">
                  <p>You don’t have to guess. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Assess your needs</span>
                    </li>
                    <li>
                      <span>Recommend the right specifications</span>
                    </li>
                    <li>
                      <span>Align with your budget</span>
                    </li>
                  </ul>
                  <p>
                    You get a well-structured, cost-effective equipment plan—not
                    trial and error.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I just buy equipment directly without going through consultation?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Browse and purchase instantly via our ICT Store (Ideal
                        for quick, straightforward purchases.)
                      </span>
                    </li>
                  </ul>
                  <p>
                    However, for structured setups (offices, schools, personal
                    professional workstations), we recommend guidance to avoid
                    costly mistakes.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What’s the difference between going direct to the store and first reaching out to you?">
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Direct to ICT Store: Fast, self-service purchases
                      </span>
                    </li>
                    <li>
                      <span>
                        Expertly Guided Purchases: Structured planning,
                        compatibility, and full setup assistance
                      </span>
                    </li>
                  </ul>
                  <p>You choose between speed or expert-led precision.</p>
                </FaqCardList>
                <FaqCardList faq="Will I end up with a complete system or just individual devices?">
                  <p>
                    It depends on what your needs are. If you reach out to us
                    first, we ensure:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>System planning</span>
                    </li>
                    <li>
                      <span>Compatibility</span>
                    </li>
                    <li>
                      <span>Integration</span>
                    </li>
                  </ul>
                  <p>
                    You get a fully structured ICT environment—not disconnected
                    equipment.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the equipment match the actual workload I need?">
                  <p>Yes. We recommend based on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>User roles</span>
                    </li>
                    <li>
                      <span>Performance needs</span>
                    </li>
                    <li>
                      <span>Real-world usage</span>
                    </li>
                  </ul>
                  <p>
                    Your systems deliver reliable performance without
                    overspending.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will everything be compatible with my existing setup?">
                  <p>Yes. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Assess current systems</span>
                    </li>
                    <li>
                      <span>Ensure compatibility</span>
                    </li>
                    <li>
                      <span>Plan integration</span>
                    </li>
                  </ul>
                  <p>Everything works seamlessly without conflicts.</p>
                </FaqCardList>
                <FaqCardList faq="Are the products in your ICT Store reliable and high quality?">
                  <p>Yes, amd assured because we supply:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Verified, trusted equipment</span>
                    </li>
                    <li>
                      <span>Quality-tested devices</span>
                    </li>
                  </ul>
                  <p>You receive reliable, long-lasting ICT tools.</p>
                </FaqCardList>
                <FaqCardList faq="Will the devices be ready to use when I receive them?">
                  <p>Yes (depending on your choice).</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Direct to Store purchases: ready or minimally setup
                      </span>
                    </li>
                    <li>
                      <span>
                        Guided consultancy: fully configured and optimized
                      </span>
                    </li>
                  </ul>
                  <p>All in all, you get working systems from day one.</p>
                </FaqCardList>
                <FaqCardList faq="Will the network and internet setup be stable?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Proper networking equipment</span>
                    </li>
                    <li>
                      <span>Structured connectivity planning</span>
                    </li>
                  </ul>
                  <p>You get fast, stable, and scalable connectivity.</p>
                </FaqCardList>
                <FaqCardList faq="Will printers and office equipment handle our workload efficiently?">
                  <p>Yes. We match devices to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Usage volume</span>
                    </li>
                    <li>
                      <span>Workflow requirements</span>
                    </li>
                  </ul>
                  <p>You get smooth and efficient operations.</p>
                </FaqCardList>
                <FaqCardList faq="Can you supply equipment for schools and computer labs?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Student systems</span>
                    </li>
                    <li>
                      <span>Lab setups</span>
                    </li>
                    <li>
                      <span>Education-ready equipment</span>
                    </li>
                  </ul>
                  <p>You get a complete, structured learning environment.</p>
                </FaqCardList>
                <FaqCardList faq="How is my data protected?">
                  <p>We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Storage solutions</span>
                    </li>
                    <li>
                      <span>Backup systems</span>
                    </li>
                    <li>
                      <span>Cybersecurity basics</span>
                    </li>
                  </ul>
                  <p>Your data is safe, accessible, and protected.</p>
                </FaqCardList>
                <FaqCardList faq="How do I handle power issues and equipment protection?">
                  <p>We can setup for you and include:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>UPS systems</span>
                    </li>
                    <li>
                      <span>Surge protection</span>
                    </li>
                    <li>
                      <span>Power planning</span>
                    </li>
                  </ul>
                  <p>
                    Your systems are protected from power damage and downtime.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I get all necessary accessories and components?">
                  <p>Yes. We ensure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>All cables and connectors</span>
                    </li>
                    <li>
                      <span>Required peripherals</span>
                    </li>
                  </ul>
                  <p>You sell you complete, ready-to-use setups.</p>
                </FaqCardList>
                <FaqCardList faq="Do you supply equipment or only install?">
                  <p>We do both.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Supply reliable equipment</span>
                    </li>
                    <li>
                      <span>Install and configure everything</span>
                    </li>
                  </ul>
                  <p>You receive a complete, ready-to-use solution.</p>
                </FaqCardList>
                <FaqCardList faq="How do you ensure everything works before delivery?">
                  <p>We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Test devices</span>
                    </li>
                    <li>
                      <span>Perform quality checks</span>
                    </li>
                    <li>
                      <span>Verify performance</span>
                    </li>
                  </ul>
                  <p>You receive fully tested equipment with no surprises.</p>
                </FaqCardList>
                <FaqCardList faq="Do you provide installation and setup?">
                  <p>Yes. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Install devices</span>
                    </li>
                    <li>
                      <span>Integrate systems</span>
                    </li>
                    <li>
                      <span>Configure networks</span>
                    </li>
                  </ul>
                  <p>Everything works seamlessly from the start.</p>
                </FaqCardList>
                <FaqCardList faq="What support do I get after purchase?">
                  <p>We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Technical support</span>
                    </li>
                    <li>
                      <span>Troubleshooting</span>
                    </li>
                    <li>
                      <span>Guidance</span>
                    </li>
                  </ul>
                  <p>You’re supported beyond delivery.</p>
                </FaqCardList>
                <FaqCardList faq="Do your products come with warranty?">
                  <p>Yes.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Manufacturer warranties</span>
                    </li>
                    <li>
                      <span>Support guidance</span>
                    </li>
                  </ul>
                  <p>You have peace of mind after purchase.</p>
                </FaqCardList>
                <FaqCardList faq="Can the equipment grow with my needs?">
                  <p>Yes. We guide and help you plan for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Scalability</span>
                    </li>
                    <li>
                      <span>Future upgrades</span>
                    </li>
                  </ul>
                  <p>Your systems remain relevant long-term.</p>
                </FaqCardList>
                <FaqCardList faq="Can you upgrade or improve my existing setup?">
                  <p>Yes. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Audit systems</span>
                    </li>
                    <li>
                      <span>Improve performance</span>
                    </li>
                    <li>
                      <span>Upgrade infrastructure</span>
                    </li>
                  </ul>
                  <p>You get a more efficient and modern setup.</p>
                </FaqCardList>
                <FaqCardList faq="What if I have a limited budget?">
                  <p>We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Prioritize essentials</span>
                    </li>
                    <li>
                      <span>Offer phased setups</span>
                    </li>
                  </ul>
                  <p>You get a functional system without overspending.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to receive equipment?">
                  <p>Depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Quantity</span>
                    </li>
                    <li>
                      <span>Type</span>
                    </li>
                    <li>
                      <span>Customization</span>
                    </li>
                  </ul>
                  <p>Timelines are clear and communicated upfront.</p>
                </FaqCardList>
                <FaqCardList faq="Do I need to be involved in the process?">
                  <p>Minimal involvement. You:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Approve recommendations</span>
                    </li>
                  </ul>
                  <p>We handle everything else.</p>
                </FaqCardList>
                <FaqCardList faq="How does your ICT School(www.ICT.ug) connect to this?">
                  <p>Our experience in training ICT skills helps us:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Recommend practical, real-world equipment</span>
                    </li>
                    <li>
                      <span>Understand actual user needs</span>
                    </li>
                    <li>
                      <span>
                        Supply tools that match learning and work environments
                      </span>
                    </li>
                  </ul>
                  <p>
                    You benefit from both technical expertise and real-world
                    training insight.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other ICT suppliers?">
                  <p>We don’t just sell equipment.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>We expertly guide decisions</span>
                    </li>
                    <li>
                      <span>Ensure compatibility</span>
                    </li>
                    <li>
                      <span>Understand actual user needs</span>
                    </li>
                    <li>
                      <span>
                        Supply tools that match learning and work environments
                      </span>
                    </li>
                    <li>
                      <span>Configure systems</span>
                    </li>
                    <li>
                      <span>Offer long-term support</span>
                    </li>
                  </ul>
                  <p>You get a complete ICT partner—not just a vendor.</p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Define all requirements</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Work on equipment configurations and delivery</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTSupplyFaqsBody;
